// order here is important, all of the modes
// are all modes above them plus more
var GuiMode = {
    RENDER        : 0,
    VIEW          : 1,
    INSPECT       : 2,
    LIMITED_EDIT  : 3,
    EDIT          : 4,
    DEV_EDIT      : 5
};

module.exports = GuiMode;